// removed by extract-text-webpack-plugin
module.exports = {"vpElementDescription":"vpElementDescription___2ebaC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/ElementDescription.module.less
// module id = 3811
// module chunks = 33